import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

const client = axios.create({
  baseURL: API,
});

client.interceptors.request.use((config) => {
  const t = localStorage.getItem("aa_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatErr(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(d);
}

export default client;
